/**
 * RateLimitBanner — exibe mensagem amigável para erros ApiError com status 429.
 *
 * OWASP: o back é a barreira real contra rate-limit; o front apenas melhora
 * a UX apresentando orientação de retry em PT-BR.
 *
 * Uso:
 *   {error?.status === 429 && <RateLimitBanner detail={error.detail} />}
 */
import { Clock } from 'lucide-react';
import { C } from '@/theme/palette';

/**
 * @param {{ detail?: string }} props
 */
export function RateLimitBanner({ detail }) {
  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '16px 20px',
        borderRadius: 8,
        backgroundColor: `${C.digital}11`,
        border: `1px solid ${C.digital}44`,
        marginBottom: 24,
      }}
    >
      <Clock
        size={18}
        aria-hidden="true"
        style={{ color: C.digital, flexShrink: 0, marginTop: 1 }}
      />
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: C.digital, marginBottom: 4 }}>
          Muitas requisições
        </div>
        <div style={{ fontSize: 13, color: C.neutralDim, lineHeight: 1.5 }}>
          {detail
            ? detail
            : 'Limite de requisições atingido. Aguarde alguns instantes antes de tentar novamente.'}
        </div>
      </div>
    </div>
  );
}
